import { render } from "./SingUpInvestigator.vue?vue&type=template&id=7d401d93"
import script from "./SingUpInvestigator.vue?vue&type=script&lang=js"
export * from "./SingUpInvestigator.vue?vue&type=script&lang=js"

import "./SingUpInvestigator.vue?vue&type=style&index=0&id=7d401d93&lang=scss"
script.render = render

export default script